'use client'

import { LuneTheme } from '@lune-fe/lune-ui-lib'
import { styled } from '@mui/material/styles'
import NLink from 'next/link'
import React from 'react'

const Link = ({
    color,
    variant,
    href,
    children,
    sx,
    newPage,
    onClick,
}: {
    color?: string
    variant?: string
    href: string
    children: React.ReactNode
    sx?: any
    newPage?: boolean
    onClick?: () => void
}) => {
    const theme = LuneTheme as { typography: any; palette: any }
    const styles = {
        ...(variant ? theme.typography[variant] : {}),
        ...(color ? { color: theme.palette[color] } : {}),
        ...(sx || {}),
    }

    const StyledLink = styled(NLink)({
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
        ...styles,
    })

    const props = {
        href,
        ...(newPage ? { target: '_blank', rel: `noreferrer` } : {}),
    }

    return (
        <StyledLink onClick={onClick} {...props}>
            {children}
        </StyledLink>
    )
}

export default Link
